import {
  CONTENT_CACHE_CONTROL,
  CONTENT_NOT_FOUND_CACHE_CONTROL,
} from "@/content/cachePolicy";
import { jsonLdVerbatim } from "@/content/schema";

/** What a CMS page route's loader hands the route, where it did not throw `notFound()`. */
type CmsPageData = { structuredData: ReadonlyArray<string> } | undefined;

/** `loaderData` is absent exactly when the loader threw `notFound()`. */
export function cmsPageHeaders({ loaderData }: { loaderData?: CmsPageData }) {
  return {
    "Cache-Control": loaderData
      ? CONTENT_CACHE_CONTROL
      : CONTENT_NOT_FOUND_CACHE_CONTROL,
  };
}

/**
 * A `script` is not hoisted by React, so the structured data is emitted from
 * the route rather than from the page's JSX. `head` runs before the loader
 * settles on a client-side navigation, so an absent `loaderData` is expected.
 */
export function cmsPageHead({ loaderData }: { loaderData?: CmsPageData }) {
  return loaderData
    ? {
        scripts: loaderData.structuredData.map((json) => ({
          type: "application/ld+json",
          children: jsonLdVerbatim(json),
        })),
      }
    : {};
}
